import * as React from "react";
const SvgKeyboardRightArrow = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 25, viewBox: "0 0 24 25", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8.29492 17.09L12.8749 12.5L8.29492 7.91L9.70492 6.5L15.7049 12.5L9.70492 18.5L8.29492 17.09Z" }));
export default SvgKeyboardRightArrow;
